import { cn } from '@/lib/utils';
import { classes } from '../classes';
export function TableHeaderActionsLoading() {
  return <div className={classes.stripe.wrapper}>
      <div className={classes.stripe.blue} />
      <div className={cn(classes.stripe.purple, classes.actions)} />
    </div>;
}